import { useState, useEffect } from 'react'
import * as allauth from '../lib/allauth'
import ProviderList from './ProviderList'
import FormErrors from '../components/FormErrors'
import { Card, Table, Button, Typography } from 'antd'

const { Title } = Typography

export default function ManageProviders () {
  const [accounts, setAccounts] = useState([])
  const [response, setResponse] = useState({ fetching: false, content: { status: 200, data: [] } })

  useEffect(() => {
    setResponse((r) => { return { ...r, fetching: true } })
    allauth.getProviderAccounts().then((resp) => {
      if (resp.status === 200) { setAccounts(resp.data) }
    }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }, [])

  function disconnect (account) {
    setResponse({ ...response, fetching: true })
    allauth.disconnectProviderAccount(account.provider.id, account.uid).then((resp) => {
      setResponse((r) => { return { ...r, content: resp } })
      if (resp.status === 200) { setAccounts(resp.data) }
    }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }

  const cols = [
    { title: 'UID', dataIndex: 'uid', key: 'uid', render: v => <code style={{ fontSize: 11 }}>{v}</code> },
    { title: 'Account', dataIndex: 'display', key: 'd' },
    { title: 'Provider', key: 'p', render: (_, r) => r.provider.name },
    { title: '', key: 'a', render: (_, r) => <Button size='small' danger onClick={() => disconnect(r)} loading={response.fetching}>Disconnect</Button> }
  ]

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <Title level={2} className='tti-page-title'>Providers</Title>
      <Card size='small' style={{ marginBottom: 16 }}>
        <Table dataSource={accounts} columns={cols} rowKey='uid' size='small' pagination={false} />
        <FormErrors errors={response.content?.errors} />
      </Card>
      <Card size='small' title='Connect'>
        <ProviderList callbackURL='/account/providers' process={allauth.AuthProcess.CONNECT} />
      </Card>
    </div>
  )
}
